import React from "react";
import "../styles/Avatar.css";

/**
 * Avatar with initials — adds a personal touch to the header/dashboard.
 */
const Avatar = ({ name = "", size = 36, onClick }) => {
  const initials = name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() || "")
    .join("");

  return (
    <button
      type="button"
      className="avatar"
      style={{ width: size, height: size, fontSize: size * 0.38 }}
      onClick={onClick}
      aria-label={`Perfil de ${name || "usuário"}`}
    >
      <span className="avatar-initials">{initials || "?"}</span>
      <span className="avatar-ring" />
    </button>
  );
};

export default Avatar;

